// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1pAVM","insightsList":"newBusinessInsightsMenu_insightsList__1dHQu","active":"newBusinessInsightsMenu_active__1mzhz"};